export default __webpack_public_path__ + "static/media/cachet-devmastery.932cb019.png";